<template>
    <div id="CustomLutV2-import-lut-modal" class="modal-new hidden">
        <span class="title">Import LUTs to "{{ folder.name }}"</span>
        <input @change="startProcess" ref="CustomLutV2ImportInput" type="file" class="d-none" multiple="" />

        <template v-if="!processing">
            <p class="description">Please select the LUTs to import</p>

            <div class="buttons-continer">
                <button type="button" class="modal-btn --primary" @click="$refs.CustomLutV2ImportInput.click()">Browse for LUTs
                </button>
                <button type="button" class="modal-btn --cancel" @click="onCancel">Cancel</button>
            </div>
        </template>

        <template v-else>
            <template v-if="uploading">
                <p class="description">Processing and uploading LUTs</p>

                <span id="import-lut-upload-percentage">{{ importProgressTotal }}%</span>
                <v-progress-linear
                    v-model="importProgressTotal"
                    :color="'#bb86fc'"
                    height="3"
                ></v-progress-linear>
            </template>

            <template v-else>
                <p class="description">Turn it up to 11! Import successful</p>

                <div class="buttons-continer --single-item">
                    <button type="button" class="modal-btn --cancel" @click="onCancel">Close</button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import prepareCustomLutForImport from "@/assets/js/CustomLuts";
import { mapState } from "vuex";
import { toString } from "lodash";

export default {
    data() {
        return {
            processing: false,
            uploading: false
        }
    },

    computed: {
        ...mapState("UserFilesCustomLuts", ["importProgressTotal", "folder"])
    },

    mounted() {
        this.$root.CustomLutV2ImportInput = this.$refs.CustomLutV2ImportInput;
    },

    methods: {
        async startProcess() {
            if (window.lutify.activeModal == window.UI.modals.customLutV2.edit.el) {
                window.UI.hideModal();
                window.UI.showModal(window.UI.modals.customLutV2.import.el);
            }

            this.$store.commit("UserFilesCustomLuts/CLEAR_IMPORT_PROGRESS");
            this.$store.commit("UserFilesCustomLuts/SET_IMPORT_PROGRESS_TOTAL", 0);

            this.processing = true;
            this.uploading = true;
            const folderId = this.$store.state.UserFilesCustomLuts.folder.id;
            const customLuts = [];
            const promises = [];
            let totalImportSize = 0;

            for await (let file of this.$refs.CustomLutV2ImportInput.files) {
                try {
                    file = await prepareCustomLutForImport(file);
                } catch (e) {
                    continue;
                }

                if (!file) continue;
                file = new File([file], file.name);

                totalImportSize += file.size;
                customLuts.push({
                    file,
                    name: file.name,
                    size: file.size
                });
            }

            this.$refs.CustomLutV2ImportInput.value = '';

            if (! await window.loader.hasFileQuota(customLuts)) {
                this.processing = false;
                return;
            }

            this.$store.commit("UserFilesCustomLuts/SET_TOTAL_IMPORT_SIZE", totalImportSize);

            const response = await this.$store.dispatch("UserFilesCustomLuts/create", {
                folder_id: folderId,
                files: customLuts
            })

            response.forEach((uploadData, key) => {
                customLuts[key].id = uploadData.id;
                customLuts[key].folderId = folderId;
                promises.push(
                    this.$store.dispatch("UserFilesCustomLuts/uploadToS3", {
                        key,
                        url: uploadData.presignedUrl,
                        file: customLuts[key].file
                    })
                )
            })

            await Promise.all(promises);
            await this.$store.dispatch("UserFilesCustomLuts/index");
            await customLutsStore.setItems(customLuts.map(lut => {
                return {
                    key: toString(lut.id),
                    value: lut
                }
            }))

            const folderIdFromActiveBlock = lutify.getActiveBlock().folder.id || lutify.getActiveBlock().selectedPreviewFolder;
            if (folderIdFromActiveBlock == folderId) lutPreviewer.showPlaceholderPreviews();

            const folder = vm.$store.getters["UserFilesCustomLuts/folder"](folderId);
            await _Adjustments.CustomLutV2.fetchCustomLutFiles(folder);

            if (folderIdFromActiveBlock == folderId) {
                lutPreviewer.removePlaceholderPreviews();
                _Adjustments.CustomLutV2.refreshAllBlocks();
                _Adjustments.CustomLutV2.showPreviews(folder);
            }

            this.uploading = false;
        },

        onCancel() {
            this.processing = false;
            this.uploading = false;
            window.UI.hideModal();
            window.UI.showModal(UI.modals.customLutV2.edit.el);
        },
    }
};
</script>
